// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTableMobileSort-Card_cls1__fk4UG","cls2":"VeloTableMobileSort-Card_cls2__6iqDk VeloTableMobileSort-Card_cls1__fk4UG"};